import {tuluPost, post,get,postAES} from "@/api/request"

export const sessionDetail = params => postAES("/v3/session/detail", params)//拍卖会详情
export const audience = params => postAES("/v3/special/detail", params)//专场详情
export const sendArtEdit = params => post("/v1/send/art/edit", params)//专场详情
export const sendArtSave = params => post("/v1/send/art/save", params)//送拍拍品 保存(临时 保存)
export const organList = params => post("/v1/send/organ/list", params)//送拍业务 start
export const classList = params => post("/v1/send/class/list", params)//送拍分类属性列表
export const sendToOrgan = params => post("/v1/send/to/organ", params)//送拍到机构 （确定 送拍）
export const checkRecordList = params => post("/v1/check/record/list", params)//机构 审核送拍列表
export const sendRecordList = params => post("/v1/send/record/list", params)//拍品送拍列表
export const sendDelCache = params => post("/v1/send/del/cache", params)//清楚送拍草稿
export const sendOtherRecordList = params => post("/v1/other/send/organ/list", params)//拍品送拍列表
export const checkRecordArtDetail = params => post("/v1/check/record/art/detail", params)//拍品送拍详情 (机构查看)
export const sendRecordArtDetail = params => post("/v1/send/record/art/detail", params)//拍品送拍详情 (用户查看)
export const sendRecordDel = params => post("/v1/send/record/del", params)//删除送拍
export const checkResult = params => post("/v1/check/result", params)//机构 审核送拍 结果
export const aucList = params => postAES("/v3/session/index", params)//拍卖会列表
export const proDetail = params => postAES("/v3/auctions/detail", params)//拍品详情
export const getMemType = params => tuluPost("/member/memberinfo", params)//获取会员类型
export const podDetail = params => tuluPost("/app/special/detail", params)//pod
//会员登录限制
export const webCheck = params => tuluPost("https://user-api.artron.net/api/device/web_check", params)

export const getMult = params => get("https://api.artron.net/v1/auction/getMult", params)//批量查询



// 搜索部分
// https://tulu-app.artron.net/app/search/getHistory
export const searchHi = params => post("/v1/search/index", params)//拍卖会列表
export const searchWord = params => post("/v1/search/associational_word", params)//联想词
// 搜索综合
export const searchZon = params => postAES("/v3/search/synthesis", params)//拍卖会列表
// 拍品  https://tulu-app.artron.net/v1/auctions/index
export const lotss = params => postAES("/v3/auctions/index", params)//拍卖会列表
// 拍卖会  https://tulu-app.artron.net/v1/session/index
export const pmwill = params => postAES("/v3/session/index", params)//拍卖会列表
// 拍卖公司  https://tulu-app.artron.net/company/search
export const pmcompany = params => postAES("/v3/organ/list/search", params)//拍卖公司
// 市场报告  https://tulu-app.artron.net/app/atreport/search
export const marketreport = params => post("/v1/search/report", params)//市场报告
// 资讯 https://tulu-app.artron.net/app/news/search
export const news = params => post("/v1/search/news", params)//资讯

// 拍卖会筛选热门公司  https://tulu-app.artron.net/app/company/recommendOrgan
export const recomm = params => post("/v1/company/recommendOrgan", params)//资讯
// https://tulu-app.artron.net/app/search/meta
export const history = params => post("/v1/search/meta", params)//全局搜索meta接口
export const getTime = params => post("/v1/common/set", params)//全局搜索meta接口
//在线竞拍按钮
export const onlineAuction = params => tuluPost("/app/session/catLogInfo",params)
export const postZoneSend = params => post("/v1/organ/zone/send/art", params)// 我要送拍
export const setBidClick = params => post("/v1/special/bid/click", params)//点击参拍
export const dirsAuction = params => post("/v1/user/enshrine/dirsAuction", params)//图录详情

export const captchaGenerate = params => post("/v2/common/captcha/generate", params)//验证码获取
export const captchaVerify = params => post("/v2/common/captcha/verify", params)//验证码校验

